import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ZoomToPerimeterService {
  gcid: any;
  constructor(private http: HttpClient) {
    //
  }

  getZoomToPerimeter(slug: string, gId: any): Observable<any> {
    return this.http.get('/map/get-active-fire-perimeters/', {
      params: { map_name: slug.toString(), perimeter_id: parseInt(gId) },
    });
  }
}
